import React, { FC, useEffect, useState } from "react";
import { ReactComponent as EditIcon } from "images/EditorIcon.svg";
import { ReactComponent as Gesture } from "images/Gesture.svg";
import { ReactComponent as StatusOkiiIcon } from "images/statusOkii.svg";
import styles from "./Menu.module.sass";
import cn from "classnames";
import { EditionOrganization } from "../EditionOrganization/EditionOrganization";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { SettingMarkers } from "../SettingMarkers/SettingMarkers";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "toolkit/hooks";

interface MenuProps {
	close: () => void;
}

interface IModalWindow {
	content: React.ReactElement | null;
	visibility: boolean;
	width: string;
}

export const Menu: FC<MenuProps> = ({ close }) => {
	const navigate = useNavigate();

	const { organizationId } = useParams();

	const { selectedOrganization } = useAppSelector((state) => state.organizations);
	const [modalWindow, setModalWindow] = useState<IModalWindow>({
		content: null,
		visibility: false,
		width: "",
	});

	const openModalWindow = (component: React.ReactElement, width: string) => {
		setModalWindow({ ...modalWindow, content: component, visibility: true, width });
	};

	const closeModalWindow = () => {
		setModalWindow({ ...modalWindow, content: null, visibility: false, width: "default" });
		close();
	};

	useEffect(() => {
		document.addEventListener("click", close);
		return () => document.removeEventListener("click", close);
		//eslint-disable-next-line
	}, []);

	return (
		<div onClick={(e) => e.stopPropagation()} className={styles.menu}>
			{modalWindow.visibility && (
				<ModalWindow close={closeModalWindow} width={modalWindow.width}>
					{modalWindow.content}
				</ModalWindow>
			)}
			<div
				onClick={() => openModalWindow(<EditionOrganization close={closeModalWindow} />, "large")}
				className={cn(styles.item, selectedOrganization?.archived && styles["item-disabled"])}>
				<div className={styles["icon-wrp"]}>
					<EditIcon />
				</div>
				<span className={styles["item-txt"]}>Редактировать</span>
			</div>
			{/* <Link to={`/`} className={styles.item}>
                <div className={styles["icon-wrp"]}><Graph className={styles.green} /></div>
                <span className={styles["item-txt"]}>Просмотреть реестр ОКИИ</span>
            </Link> */}
			<div
				onClick={() => openModalWindow(<SettingMarkers close={closeModalWindow} />, "big")}
				className={cn(styles.item, selectedOrganization?.archived && styles["item-disabled"])}>
				<div className={styles["icon-wrp"]}>
					<Gesture className={styles.yellow} />
				</div>
				<span className={styles["item-txt"]}>Настроить маркеры</span>
			</div>

			<div
				onClick={() =>
					navigate(`/organization/${organizationId}/statusOkii`, {
						state: { organizationName: selectedOrganization?.fullName },
					})
				}
				className={cn(styles.item, selectedOrganization?.archived && styles["item-disabled"])}>
				<div className={styles["icon-wrp"]}>
					<StatusOkiiIcon className={styles.yellow} />
				</div>
				<span className={styles["item-txt"]}>Cтатус категорирования ОКИИ</span>
			</div>
		</div>
	);
};
